module.exports = __webpack_public_path__ + "img/6.d6adcb8b.jpg";